<div class="c-text-input___validation">
    {{message}}
</div>
